var map = {
	"./ramenChesse-160-160.webp": 4007,
	"./ramenClasico-160-160.webp": 3080,
	"./ramenMarisco-160-160.webp": 4222,
	"./ramenMiso-160-160.webp": 836,
	"./ramenPicante-160-160.webp": 4804,
	"./ramenTonkotsu-160-160.webp": 6933
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 813;